import React, { useState, useEffect } from 'react';
import Navbar from '../../Navbar/Navbar';
import { ChatWindow, formatFullNameToShort, getInitials } from './ChatWindow';

const API = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

function fmtConvo(iso) {
  if (!iso) return '';
  const d = new Date(iso), now = new Date();
  const diff = Math.floor((now - d) / 86400000);
  if (diff === 0) return d.toLocaleTimeString('en-US',{hour:'numeric',minute:'2-digit'});
  if (diff === 1) return 'Yesterday';
  if (diff < 7)   return d.toLocaleDateString('en-US',{weekday:'short'});
  return d.toLocaleDateString('en-US',{month:'short',day:'numeric'});
}

function ConvoRow({ c, active, onClick, currentUser, D }) {
  const name      = formatFullNameToShort(c.partner_first_name, c.partner_last_name, c.partner_name || c.partner_email);
  const initials  = getInitials(name);
  const hasUnread = c.unread_count > 0;
  const preview   = c.last_message_text
    ? (c.last_message_text.length > 45 ? c.last_message_text.slice(0,45)+'…' : c.last_message_text)
    : 'No messages yet';

  const bg    = D ? (active?'rgba(59,130,246,0.20)':'transparent') : (active?'#dbeafe':'transparent');
  const hov   = D ? 'rgba(255,255,255,0.05)' : '#f7f8fa';
  const txtC  = D ? '#f0f4f8' : '#111827';
  const subC  = D ? '#94a3b8' : '#6b7280';
  const bdrC  = D ? '#1e293b' : '#e5e7eb';

  return (
    <div onClick={onClick}
      style={{ display:'flex', alignItems:'center', gap:10, padding:'11px 14px', cursor:'pointer',
        background:bg, borderBottom:`1px solid ${bdrC}`, transition:'background 0.12s',
        borderLeft: active ? '3px solid #3b82f6' : '3px solid transparent' }}
      onMouseEnter={e=>{ if(!active) e.currentTarget.style.background=hov; }}
      onMouseLeave={e=>{ e.currentTarget.style.background = active?bg:'transparent'; }}>
      <div style={{ position:'relative', flexShrink:0 }}>
        <div style={{ width:44, height:44, borderRadius:'50%',
          background:'linear-gradient(135deg,#06b6d4,#3b82f6)',
          display:'flex', alignItems:'center', justifyContent:'center',
          fontWeight:800, fontSize:14, color:'#fff' }}>
          {initials}
        </div>
        {hasUnread && (
          <span style={{ position:'absolute', bottom:1, right:1, width:12, height:12,
            borderRadius:'50%', background:'#ef4444', border:'2px solid white', display:'block' }}/>
        )}
      </div>
      <div style={{ flex:1, minWidth:0 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:2 }}>
          <span style={{ fontWeight:700, fontSize:13, color:txtC, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
            {name}
          </span>
          <span style={{ fontSize:11, color:subC, whiteSpace:'nowrap', marginLeft:6 }}>
            {fmtConvo(c.updated_at)}
          </span>
        </div>
        <div style={{ fontSize:12, color:hasUnread?txtC:subC, fontWeight:hasUnread?700:400,
          overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {preview}
        </div>
        <div style={{ fontSize:11, marginTop:2, color:'#0891b2', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          🏷️ {c.listing_title}
        </div>
      </div>
    </div>
  );
}

export default function TradeLinkInbox({ isDarkMode, toggleTheme }) {
  const D = !!isDarkMode;
  const [conversations, setConversations] = useState([]);
  const [activeConvo,   setActiveConvo]   = useState(null);
  const [currentUser,   setCurrentUser]   = useState(null);
  const [narrow, setNarrow] = useState(window.innerWidth < 640);

  useEffect(() => {
    const fn = () => setNarrow(window.innerWidth < 640);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('user_token');
    const user  = localStorage.getItem('user');
    if (user) { try { setCurrentUser(JSON.parse(user)); } catch {} }
    if (!token) return;

    fetch(`${API}/api/tradelink/chat/inbox/`, {
      headers: { Authorization:`Token ${token}`, 'Content-Type':'application/json' },
    })
      .then(r => r.ok ? r.json() : Promise.reject(r))
      .then(data => {
        const arr = Array.isArray(data) ? data : (data.results || []);
        setConversations(arr);
        if (arr.length > 0 && !narrow) setActiveConvo(arr[0]);
      })
      .catch(() => setConversations([]));
  }, [narrow]);

  const showList = !narrow || !activeConvo;
  const showChat = !narrow || !!activeConvo;

  // tokens
  const pageBg  = D ? '#0f172a' : '#f8fafc';
  const sidebarBg = D ? '#1e293b' : '#ffffff';
  const headerBg  = D ? '#0f172a' : '#0f172a';
  const bdrC      = D ? '#334155' : '#e5e7eb';
  const txtC      = D ? '#f0f4f8' : '#111827';
  const mutedC    = D ? '#94a3b8' : '#6b7280';
  const searchBg  = D ? '#0f172a' : '#f7f8fa';

  return (
    <div style={{ minHeight:'100vh', background:pageBg, fontFamily:"'Inter','DM Sans',sans-serif", display:'flex', flexDirection:'column' }}>
      <Navbar isDarkMode={D} toggleTheme={toggleTheme}/>

      <div style={{ display:'flex', height:'calc(100vh - 62px)', overflow:'hidden', background:pageBg }}>

        {/* Sidebar */}
        {showList && (
          <div style={{ width:narrow?'100%':320, flexShrink:0, borderRight:narrow?'none':`1px solid ${bdrC}`,
            height:'100%', background:sidebarBg, display:'flex', flexDirection:'column' }}>

            {/* Header */}
            <div style={{ background:headerBg, padding:'14px 16px',
              display:'flex', justifyContent:'space-between', alignItems:'center', flexShrink:0 }}>
              <div style={{ fontWeight:800, fontSize:17, color:'#fff' }}>Trade Link 🛒</div>
              <div style={{ background:'rgba(255,255,255,0.12)', borderRadius:99,
                padding:'3px 10px', fontSize:11, color:'rgba(255,255,255,0.65)', fontWeight:700 }}>
                {conversations.length} chats
              </div>
            </div>

            {/* Search */}
            <div style={{ padding:'10px 12px', borderBottom:`1px solid ${bdrC}`, flexShrink:0 }}>
              <div style={{ background:searchBg, border:`1px solid ${bdrC}`, borderRadius:22,
                padding:'8px 14px', display:'flex', alignItems:'center', gap:8, fontSize:13, color:mutedC }}>
                <span>🔍</span><span>Search messages…</span>
              </div>
            </div>

            {/* List */}
            <div style={{ flex:1, overflowY:'auto' }}>
              {conversations.map(c => (
                <ConvoRow key={c.id} c={c} active={activeConvo?.id===c.id}
                  onClick={()=>setActiveConvo(c)} currentUser={currentUser} D={D}/>
              ))}
              {conversations.length === 0 && (
                <div style={{ padding:'40px 20px', textAlign:'center', color:mutedC, fontSize:14 }}>
                  No active conversations.
                </div>
              )}
            </div>
          </div>
        )}

        {/* Chat */}
        {showChat && (
          <div style={{ flex:1, height:'100%', minWidth:0, overflow:'hidden' }}>
            {activeConvo ? (
              <ChatWindow activeConvo={activeConvo} currentUser={currentUser}
                isDark={D} onBack={()=>setActiveConvo(null)}/>
            ) : (
              <div style={{ flex:1, height:'100%', display:'flex', flexDirection:'column',
                alignItems:'center', justifyContent:'center', gap:12,
                color:mutedC, background:D?'#0f172a':'#efeae2' }}>
                <div style={{ fontSize:44 }}>💬</div>
                <div style={{ fontWeight:700, fontSize:16, color:D?'#94a3b8':'#64748b' }}>Trade Link Chat</div>
                <div style={{ fontSize:13 }}>Select a conversation to start</div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
